function PlanV({ ...props }) {
	return (
		<g {...props} id="unit-v">
			<g id="furniture">
				<polyline
					points="542.95 594.49 540.44 594.49 540.44 589.53 542.95 589.53 542.95 594.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="280"
					y1="506.3"
					x2="148.33"
					y2="506.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.7"
					y1="543.95"
					x2="202.72"
					y2="543.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.33"
					y1="543.95"
					x2="212.36"
					y2="543.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.97"
					y1="543.95"
					x2="222"
					y2="543.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.61"
					y1="543.95"
					x2="231.63"
					y2="543.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280"
					y1="524.57"
					x2="280"
					y2="518.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280"
					y1="514.93"
					x2="280"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280"
					y1="508.81"
					x2="273.8"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.18"
					y1="508.81"
					x2="264.16"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.55"
					y1="508.81"
					x2="254.52"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.91"
					y1="508.81"
					x2="244.88"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.27"
					y1="508.81"
					x2="235.25"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.63"
					y1="508.81"
					x2="225.61"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222"
					y1="508.81"
					x2="215.97"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.36"
					y1="508.81"
					x2="206.33"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.72"
					y1="508.81"
					x2="196.7"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.08"
					y1="508.81"
					x2="187.06"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.44"
					y1="508.81"
					x2="177.42"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.81"
					y1="508.81"
					x2="167.78"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="164.17"
					y1="508.81"
					x2="158.15"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="154.53"
					y1="508.81"
					x2="148.33"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.33"
					y1="508.81"
					x2="148.33"
					y2="514.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.33"
					y1="518.55"
					x2="148.33"
					y2="524.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="242.56 579.05 242.56 646.82 174.79 646.82 174.79 579.05 242.56 579.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="374.01 56.45 331.56 56.45 331.56 61.89 374.01 61.89 374.01 56.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.58 55.96 375.99 55.96 375.99 56.45 329.58 56.45 329.58 55.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="329.58"
					y1="55.96"
					x2="375.99"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.99"
					y1="55.96"
					x2="375.99"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.99"
					y1="56.45"
					x2="329.58"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.58"
					y1="56.45"
					x2="329.58"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.01"
					y1="61.89"
					x2="331.56"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.56"
					y1="56.45"
					x2="374.01"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="378.46 61.89 374.01 61.89 374.01 56.45 378.46 56.45 378.46 61.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="378.46"
					y1="61.89"
					x2="374.01"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.01"
					y1="61.89"
					x2="374.01"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.01"
					y1="56.45"
					x2="378.46"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.46"
					y1="56.45"
					x2="378.46"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="327.11 56.45 331.56 56.45 331.56 61.89 327.11 61.89 327.11 56.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="327.11"
					y1="56.45"
					x2="331.56"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.56"
					y1="56.45"
					x2="331.56"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.56"
					y1="61.89"
					x2="327.11"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.11"
					y1="61.89"
					x2="327.11"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.01"
					y1="57.44"
					x2="331.56"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="380.44 61.39 378.46 61.39 378.46 56.45 375.99 56.45 375.99 55.96 380.44 55.96 380.44 61.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="380.44"
					y1="61.39"
					x2="378.46"
					y2="61.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.46"
					y1="61.39"
					x2="378.46"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.46"
					y1="56.45"
					x2="375.99"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.99"
					y1="56.45"
					x2="375.99"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.99"
					y1="55.96"
					x2="380.44"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.44"
					y1="55.96"
					x2="380.44"
					y2="61.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="325.14 55.96 329.58 55.96 329.58 56.45 327.11 56.45 327.11 61.39 325.14 61.39 325.14 55.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="325.14"
					y1="55.96"
					x2="329.58"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.58"
					y1="55.96"
					x2="329.58"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.58"
					y1="56.45"
					x2="327.11"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.11"
					y1="56.45"
					x2="327.11"
					y2="61.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.11"
					y1="61.39"
					x2="325.14"
					y2="61.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.14"
					y1="61.39"
					x2="325.14"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="322.63 57.44 322.63 59.95 219.67 59.95 219.67 57.44 322.63 57.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="322.63"
					y1="57.44"
					x2="322.63"
					y2="59.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.63"
					y1="59.95"
					x2="219.67"
					y2="59.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.67"
					y1="59.95"
					x2="219.67"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.67"
					y1="57.44"
					x2="322.63"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="380.44 57.44 385.46 57.44 385.46 72.5 380.44 72.5 380.44 57.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="385.46"
					y1="57.44"
					x2="380.44"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.46"
					y1="72.5"
					x2="385.46"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.44"
					y1="72.5"
					x2="385.46"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.44"
					y1="57.44"
					x2="380.44"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="320.12 57.44 325.14 57.44 325.14 72.5 320.12 72.5 320.12 57.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="325.14"
					y1="57.44"
					x2="320.12"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.14"
					y1="72.5"
					x2="325.14"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.12"
					y1="72.5"
					x2="325.14"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.12"
					y1="57.44"
					x2="320.12"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="217.16 57.44 222.18 57.44 222.18 72.5 217.16 72.5 217.16 57.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="222.18"
					y1="57.44"
					x2="217.16"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.18"
					y1="72.5"
					x2="222.18"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.16"
					y1="72.5"
					x2="222.18"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.16"
					y1="57.44"
					x2="217.16"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="705.45 56.45 663 56.45 663 61.89 705.45 61.89 705.45 56.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="661.03 55.96 707.43 55.96 707.43 56.45 661.03 56.45 661.03 55.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="661.03"
					y1="55.96"
					x2="707.43"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.43"
					y1="55.96"
					x2="707.43"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.43"
					y1="56.45"
					x2="661.03"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.03"
					y1="56.45"
					x2="661.03"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.45"
					y1="61.89"
					x2="663"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663"
					y1="56.45"
					x2="705.45"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="709.9 61.89 705.45 61.89 705.45 56.45 709.9 56.45 709.9 61.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="709.9"
					y1="61.89"
					x2="705.45"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.45"
					y1="61.89"
					x2="705.45"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.45"
					y1="56.45"
					x2="709.9"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.9"
					y1="56.45"
					x2="709.9"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="658.55 56.45 663 56.45 663 61.89 658.55 61.89 658.55 56.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="658.55"
					y1="56.45"
					x2="663"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663"
					y1="56.45"
					x2="663"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663"
					y1="61.89"
					x2="658.55"
					y2="61.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.55"
					y1="61.89"
					x2="658.55"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.45"
					y1="57.44"
					x2="663"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="711.87 61.39 709.9 61.39 709.9 56.45 707.43 56.45 707.43 55.96 711.87 55.96 711.87 61.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="711.87"
					y1="61.39"
					x2="709.9"
					y2="61.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.9"
					y1="61.39"
					x2="709.9"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.9"
					y1="56.45"
					x2="707.43"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.43"
					y1="56.45"
					x2="707.43"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.43"
					y1="55.96"
					x2="711.87"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.87"
					y1="55.96"
					x2="711.87"
					y2="61.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="656.58 55.96 661.03 55.96 661.03 56.45 658.55 56.45 658.55 61.39 656.58 61.39 656.58 55.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="656.58"
					y1="55.96"
					x2="661.03"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.03"
					y1="55.96"
					x2="661.03"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.03"
					y1="56.45"
					x2="658.55"
					y2="56.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.55"
					y1="56.45"
					x2="658.55"
					y2="61.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.55"
					y1="61.39"
					x2="656.58"
					y2="61.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.58"
					y1="61.39"
					x2="656.58"
					y2="55.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="654.07 57.44 654.07 59.95 525.23 59.95 525.23 57.44 654.07 57.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="654.07"
					y1="57.44"
					x2="654.07"
					y2="59.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.07"
					y1="59.95"
					x2="525.23"
					y2="59.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.23"
					y1="59.95"
					x2="525.23"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.23"
					y1="57.44"
					x2="654.07"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="711.87 57.44 716.9 57.44 716.9 72.5 711.87 72.5 711.87 57.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="716.9"
					y1="57.44"
					x2="711.87"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.9"
					y1="72.5"
					x2="716.9"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.87"
					y1="72.5"
					x2="716.9"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.87"
					y1="57.44"
					x2="711.87"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="651.56 57.44 656.58 57.44 656.58 72.5 651.56 72.5 651.56 57.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="656.58"
					y1="57.44"
					x2="651.56"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.58"
					y1="72.5"
					x2="656.58"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.56"
					y1="72.5"
					x2="656.58"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.56"
					y1="57.44"
					x2="651.56"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="522.72 57.44 527.74 57.44 527.74 72.5 522.72 72.5 522.72 57.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="527.74"
					y1="57.44"
					x2="522.72"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.74"
					y1="72.5"
					x2="527.74"
					y2="57.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.72"
					y1="72.5"
					x2="527.74"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.72"
					y1="57.44"
					x2="522.72"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.88"
					y1="926.25"
					x2="493.88"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.51"
					y1="946.33"
					x2="394.74"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.51"
					y1="926.25"
					x2="394.74"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.51"
					y1="926.25"
					x2="398.51"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="399.76 947.58 399.76 946.33 394.74 946.33 394.74 947.58 399.76 947.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="399.76 926.25 399.76 924.99 394.74 924.99 394.74 926.25 399.76 926.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="399.76"
					y1="947.58"
					x2="394.74"
					y2="947.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.74"
					y1="947.58"
					x2="394.74"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.74"
					y1="946.33"
					x2="399.76"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.76"
					y1="946.33"
					x2="399.76"
					y2="947.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.63"
					y1="947.58"
					x2="492.63"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.76"
					y1="926.25"
					x2="394.74"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.74"
					y1="926.25"
					x2="394.74"
					y2="924.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.74"
					y1="924.99"
					x2="399.76"
					y2="924.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.76"
					y1="924.99"
					x2="399.76"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.63"
					y1="926.25"
					x2="492.63"
					y2="924.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="401.02 946.33 401.02 926.25 399.13 926.25 399.13 946.33 401.02 946.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="493.25 946.33 493.25 926.25 491.37 926.25 491.37 946.33 493.25 946.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="427.48 862.36 424.38 865.47 488.26 929.36 491.37 926.25 427.48 862.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="399.13"
					y1="926.25"
					x2="398.51"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.13"
					y1="946.33"
					x2="398.51"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.51"
					y1="926.25"
					x2="398.51"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.25"
					y1="926.25"
					x2="493.88"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.25"
					y1="946.33"
					x2="493.88"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.88"
					y1="926.25"
					x2="493.88"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.02"
					y1="946.33"
					x2="401.02"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.02"
					y1="926.25"
					x2="399.13"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.13"
					y1="926.25"
					x2="399.13"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.13"
					y1="946.33"
					x2="401.02"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.25"
					y1="946.33"
					x2="493.25"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.25"
					y1="926.25"
					x2="491.37"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.37"
					y1="926.25"
					x2="491.37"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.37"
					y1="946.33"
					x2="493.25"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.48"
					y1="862.36"
					x2="424.38"
					y2="865.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.38"
					y1="865.47"
					x2="488.26"
					y2="929.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.26"
					y1="929.36"
					x2="491.37"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.37"
					y1="926.25"
					x2="427.48"
					y2="862.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.51"
					y1="926.25"
					x2="398.51"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.51"
					y1="926.25"
					x2="398.51"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.51"
					y1="926.25"
					x2="394.74"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.51"
					y1="926.25"
					x2="394.74"
					y2="926.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.51"
					y1="946.33"
					x2="394.74"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="398.51"
					y1="946.33"
					x2="394.74"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="493.88"
					y1="926.25"
					x2="493.88"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="493.88"
					y1="926.25"
					x2="493.88"
					y2="946.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="158.56"
					y1="769.27"
					x2="172.58"
					y2="769.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="172.58"
					y1="769.27"
					x2="172.58"
					y2="690.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="217.16"
					y1="52.42"
					x2="217.16"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="503.32"
					y1="686.76"
					x2="523.4"
					y2="686.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="613.22"
					y1="686.76"
					x2="523.4"
					y2="686.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="613.22"
					y1="663.46"
					x2="613.22"
					y2="676.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="613.22"
					y1="676.01"
					x2="613.22"
					y2="686.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="339.7"
					y1="912.78"
					x2="339.7"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="912.78"
					x2="327.15"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="912.78"
					x2="339.7"
					y2="912.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="339.7"
					y1="832.46"
					x2="339.7"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="832.46"
					x2="327.15"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="832.46"
					x2="339.7"
					y2="832.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="340.95 833.72 340.95 828.7 339.7 828.7 339.7 833.72 340.95 833.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="339.7 911.52 339.7 916.54 340.95 916.54 340.95 911.52 339.7 911.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.15 833.72 327.15 828.7 325.9 828.7 325.9 833.72 327.15 833.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="325.9 911.52 325.9 916.54 327.15 916.54 327.15 911.52 325.9 911.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="340.95"
					y1="833.72"
					x2="340.95"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.95"
					y1="828.7"
					x2="339.7"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="828.7"
					x2="339.7"
					y2="833.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="833.72"
					x2="340.95"
					y2="833.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="911.52"
					x2="339.7"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="916.54"
					x2="340.95"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.95"
					y1="916.54"
					x2="340.95"
					y2="911.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.95"
					y1="911.52"
					x2="339.7"
					y2="911.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="833.72"
					x2="327.15"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="828.7"
					x2="325.9"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.9"
					y1="828.7"
					x2="325.9"
					y2="833.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.9"
					y1="833.72"
					x2="327.15"
					y2="833.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.9"
					y1="911.52"
					x2="325.9"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.9"
					y1="916.54"
					x2="327.15"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="916.54"
					x2="327.15"
					y2="911.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="911.52"
					x2="325.9"
					y2="911.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="339.7 834.97 339.7 833.09 327.15 833.09 327.15 834.97 339.7 834.97"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="339.7 912.15 339.7 910.27 327.15 910.27 327.15 912.15 339.7 912.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="273.91 857.02 327.15 910.27 330.26 907.16 277.01 853.92 273.91 857.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="327.15"
					y1="833.09"
					x2="327.15"
					y2="832.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="833.09"
					x2="339.7"
					y2="832.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="832.46"
					x2="339.7"
					y2="832.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="912.15"
					x2="327.15"
					y2="912.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="912.15"
					x2="339.7"
					y2="912.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="912.78"
					x2="339.7"
					y2="912.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="834.97"
					x2="327.15"
					y2="834.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="834.97"
					x2="327.15"
					y2="833.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="833.09"
					x2="339.7"
					y2="833.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="833.09"
					x2="339.7"
					y2="834.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="912.15"
					x2="327.15"
					y2="912.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="912.15"
					x2="327.15"
					y2="910.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="910.27"
					x2="339.7"
					y2="910.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.7"
					y1="910.27"
					x2="339.7"
					y2="912.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.91"
					y1="857.02"
					x2="277.01"
					y2="853.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.01"
					y1="853.92"
					x2="330.26"
					y2="907.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.26"
					y1="907.16"
					x2="327.15"
					y2="910.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="910.27"
					x2="273.91"
					y2="857.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="832.46"
					x2="339.7"
					y2="832.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="832.46"
					x2="339.7"
					y2="832.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="832.46"
					x2="327.15"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="832.46"
					x2="327.15"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="339.7"
					y1="832.46"
					x2="339.7"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="339.7"
					y1="832.46"
					x2="339.7"
					y2="828.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="912.78"
					x2="339.7"
					y2="912.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="912.78"
					x2="339.7"
					y2="912.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="912.78"
					x2="327.15"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="327.15"
					y1="912.78"
					x2="327.15"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="339.7"
					y1="912.78"
					x2="339.7"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="339.7"
					y1="912.78"
					x2="339.7"
					y2="916.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="172.58"
					y1="690.34"
					x2="327.15"
					y2="690.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="245.25"
					y1="655.08"
					x2="245.25"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="655.08"
					x2="257.8"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="655.08"
					x2="245.25"
					y2="655.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="245.25"
					y1="574.76"
					x2="245.25"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="574.76"
					x2="257.8"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="574.76"
					x2="245.25"
					y2="574.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="244 576.02 245.25 576.02 245.25 571 244 571 244 576.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="245.25 653.82 244 653.82 244 658.84 245.25 658.84 245.25 653.82"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="257.8 576.02 259.06 576.02 259.06 571 257.8 571 257.8 576.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="259.06 653.82 257.8 653.82 257.8 658.84 259.06 658.84 259.06 653.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="244"
					y1="576.02"
					x2="244"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244"
					y1="571"
					x2="245.25"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="571"
					x2="245.25"
					y2="576.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="576.02"
					x2="244"
					y2="576.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="653.82"
					x2="245.25"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="658.84"
					x2="244"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244"
					y1="658.84"
					x2="244"
					y2="653.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244"
					y1="653.82"
					x2="245.25"
					y2="653.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="576.02"
					x2="257.8"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="571"
					x2="259.06"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.06"
					y1="571"
					x2="259.06"
					y2="576.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.06"
					y1="576.02"
					x2="257.8"
					y2="576.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.06"
					y1="653.82"
					x2="259.06"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.06"
					y1="658.84"
					x2="257.8"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="658.84"
					x2="257.8"
					y2="653.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="653.82"
					x2="259.06"
					y2="653.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="245.25 577.27 257.8 577.27 257.8 575.39 245.25 575.39 245.25 577.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="245.25 654.45 257.8 654.45 257.8 652.56 245.25 652.56 245.25 654.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="311.04 599.32 307.94 596.22 254.7 649.46 257.8 652.56 311.04 599.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="257.8"
					y1="575.39"
					x2="257.8"
					y2="574.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="575.39"
					x2="245.25"
					y2="574.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="574.76"
					x2="245.25"
					y2="574.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="654.45"
					x2="257.8"
					y2="655.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="654.45"
					x2="245.25"
					y2="655.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="655.08"
					x2="245.25"
					y2="655.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="577.27"
					x2="257.8"
					y2="577.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="577.27"
					x2="257.8"
					y2="575.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="575.39"
					x2="245.25"
					y2="575.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="575.39"
					x2="245.25"
					y2="577.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="654.45"
					x2="257.8"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="654.45"
					x2="257.8"
					y2="652.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="652.56"
					x2="245.25"
					y2="652.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.25"
					y1="652.56"
					x2="245.25"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.04"
					y1="599.32"
					x2="307.94"
					y2="596.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.94"
					y1="596.22"
					x2="254.7"
					y2="649.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.7"
					y1="649.46"
					x2="257.8"
					y2="652.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="652.56"
					x2="311.04"
					y2="599.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.8"
					y1="574.76"
					x2="245.25"
					y2="574.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="574.76"
					x2="245.25"
					y2="574.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="574.76"
					x2="257.8"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="574.76"
					x2="257.8"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="245.25"
					y1="574.76"
					x2="245.25"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="245.25"
					y1="574.76"
					x2="245.25"
					y2="571"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="655.08"
					x2="245.25"
					y2="655.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="655.08"
					x2="245.25"
					y2="655.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="655.08"
					x2="257.8"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="257.8"
					y1="655.08"
					x2="257.8"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="245.25"
					y1="655.08"
					x2="245.25"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="245.25"
					y1="655.08"
					x2="245.25"
					y2="658.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="487.4"
					x2="406.7"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="474.85"
					x2="406.7"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="474.85"
					x2="402.94"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="322.63"
					y1="487.4"
					x2="318.86"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="322.63"
					y1="474.85"
					x2="318.86"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="322.63"
					y1="474.85"
					x2="322.63"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="323.88 488.65 323.88 487.4 318.86 487.4 318.86 488.65 323.88 488.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="401.69 487.4 401.69 488.65 406.7 488.65 406.7 487.4 401.69 487.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="323.88 474.85 323.88 473.59 318.86 473.59 318.86 474.85 323.88 474.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="401.69 473.59 401.69 474.85 406.7 474.85 406.7 473.59 401.69 473.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="323.88"
					y1="488.65"
					x2="318.86"
					y2="488.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.86"
					y1="488.65"
					x2="318.86"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.86"
					y1="487.4"
					x2="323.88"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.88"
					y1="487.4"
					x2="323.88"
					y2="488.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.69"
					y1="487.4"
					x2="406.7"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.7"
					y1="487.4"
					x2="406.7"
					y2="488.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.7"
					y1="488.65"
					x2="401.69"
					y2="488.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.69"
					y1="488.65"
					x2="401.69"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.88"
					y1="474.85"
					x2="318.86"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.86"
					y1="474.85"
					x2="318.86"
					y2="473.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.86"
					y1="473.59"
					x2="323.88"
					y2="473.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.88"
					y1="473.59"
					x2="323.88"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.69"
					y1="473.59"
					x2="406.7"
					y2="473.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.7"
					y1="473.59"
					x2="406.7"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.7"
					y1="474.85"
					x2="401.69"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.69"
					y1="474.85"
					x2="401.69"
					y2="473.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="325.14 487.4 325.14 474.85 323.25 474.85 323.25 487.4 325.14 487.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="402.31 487.4 402.31 474.85 400.43 474.85 400.43 487.4 402.31 487.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="347.19 421.61 344.08 424.71 397.33 477.95 400.43 474.85 347.19 421.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="323.25"
					y1="474.85"
					x2="322.63"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.25"
					y1="487.4"
					x2="322.63"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.63"
					y1="474.85"
					x2="322.63"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.31"
					y1="474.85"
					x2="402.94"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.31"
					y1="487.4"
					x2="402.94"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.94"
					y1="474.85"
					x2="402.94"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.14"
					y1="487.4"
					x2="325.14"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.14"
					y1="474.85"
					x2="323.25"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.25"
					y1="474.85"
					x2="323.25"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.25"
					y1="487.4"
					x2="325.14"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.31"
					y1="487.4"
					x2="402.31"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.31"
					y1="474.85"
					x2="400.43"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.43"
					y1="474.85"
					x2="400.43"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.43"
					y1="487.4"
					x2="402.31"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.19"
					y1="421.61"
					x2="344.08"
					y2="424.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.08"
					y1="424.71"
					x2="397.33"
					y2="477.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.33"
					y1="477.95"
					x2="400.43"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.43"
					y1="474.85"
					x2="347.19"
					y2="421.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.63"
					y1="474.85"
					x2="322.63"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="322.63"
					y1="474.85"
					x2="322.63"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="322.63"
					y1="474.85"
					x2="318.86"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="322.63"
					y1="474.85"
					x2="318.86"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="322.63"
					y1="487.4"
					x2="318.86"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="322.63"
					y1="487.4"
					x2="318.86"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="474.85"
					x2="402.94"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="474.85"
					x2="402.94"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="474.85"
					x2="406.7"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="474.85"
					x2="406.7"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="487.4"
					x2="406.7"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="402.94"
					y1="487.4"
					x2="406.7"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="487.4"
					x2="172.74"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="474.85"
					x2="172.74"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="474.85"
					x2="176.51"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="256.82"
					y1="487.4"
					x2="260.59"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="256.82"
					y1="474.85"
					x2="260.59"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="256.82"
					y1="474.85"
					x2="256.82"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="255.57 488.65 260.59 488.65 260.59 487.4 255.57 487.4 255.57 488.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="177.76 487.4 172.74 487.4 172.74 488.65 177.76 488.65 177.76 487.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="255.57 474.85 260.59 474.85 260.59 473.59 255.57 473.59 255.57 474.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="177.76 473.59 172.74 473.59 172.74 474.85 177.76 474.85 177.76 473.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="255.57"
					y1="488.65"
					x2="260.59"
					y2="488.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.59"
					y1="488.65"
					x2="260.59"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.59"
					y1="487.4"
					x2="255.57"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.57"
					y1="487.4"
					x2="255.57"
					y2="488.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.76"
					y1="487.4"
					x2="172.74"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.74"
					y1="487.4"
					x2="172.74"
					y2="488.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.74"
					y1="488.65"
					x2="177.76"
					y2="488.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.76"
					y1="488.65"
					x2="177.76"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.57"
					y1="474.85"
					x2="260.59"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.59"
					y1="474.85"
					x2="260.59"
					y2="473.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.59"
					y1="473.59"
					x2="255.57"
					y2="473.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.57"
					y1="473.59"
					x2="255.57"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.76"
					y1="473.59"
					x2="172.74"
					y2="473.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.74"
					y1="473.59"
					x2="172.74"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.74"
					y1="474.85"
					x2="177.76"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.76"
					y1="474.85"
					x2="177.76"
					y2="473.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="254.31 487.4 256.19 487.4 256.19 474.85 254.31 474.85 254.31 487.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="177.14 487.4 179.02 487.4 179.02 474.85 177.14 474.85 177.14 487.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="232.26 421.61 179.02 474.85 182.12 477.95 235.37 424.71 232.26 421.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="256.19"
					y1="474.85"
					x2="256.82"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.19"
					y1="487.4"
					x2="256.82"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.82"
					y1="474.85"
					x2="256.82"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.14"
					y1="474.85"
					x2="176.51"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.14"
					y1="487.4"
					x2="176.51"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.51"
					y1="474.85"
					x2="176.51"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.31"
					y1="487.4"
					x2="254.31"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.31"
					y1="474.85"
					x2="256.19"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.19"
					y1="474.85"
					x2="256.19"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.19"
					y1="487.4"
					x2="254.31"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.14"
					y1="487.4"
					x2="177.14"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.14"
					y1="474.85"
					x2="179.02"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.02"
					y1="474.85"
					x2="179.02"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.02"
					y1="487.4"
					x2="177.14"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.26"
					y1="421.61"
					x2="235.37"
					y2="424.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.37"
					y1="424.71"
					x2="182.12"
					y2="477.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.12"
					y1="477.95"
					x2="179.02"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.02"
					y1="474.85"
					x2="232.26"
					y2="421.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.82"
					y1="474.85"
					x2="256.82"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="256.82"
					y1="474.85"
					x2="256.82"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="256.82"
					y1="474.85"
					x2="260.59"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="256.82"
					y1="474.85"
					x2="260.59"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="256.82"
					y1="487.4"
					x2="260.59"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="256.82"
					y1="487.4"
					x2="260.59"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="474.85"
					x2="176.51"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="474.85"
					x2="176.51"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="474.85"
					x2="172.74"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="474.85"
					x2="172.74"
					y2="474.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="487.4"
					x2="172.74"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="176.51"
					y1="487.4"
					x2="172.74"
					y2="487.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="716.9"
					y1="52.42"
					x2="716.9"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="522.72"
					y1="72.5"
					x2="522.72"
					y2="52.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="385.46"
					y1="52.42"
					x2="385.46"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="224.47 887.21 226.47 882.73 227.16 877.88 226.47 873.02 224.47 868.54 221.93 865.59 218.75 863.35 211.28 860.51 205.08 859.51 198.81 859.88 192.77 861.62 187.25 861.48 181.9 860.08 177.02 857.5 174.89 856.15 170.53 854.56 165.9 854.8 164.07 855.51 159.19 855.51 159.19 857.55 161.41 857.55 159.36 860.95 158.56 864.84 158.56 890.91 159.92 895.95 163.51 899.74 168.46 901.36 169.06 901.36 172.2 900.84 177.13 898.2 181.96 895.64 187.24 894.25 192.71 894.11 198.76 895.86 205.06 896.25 211.28 895.25 218.75 892.4 221.93 890.16 224.47 887.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="181.73"
					y1="868.59"
					x2="181.73"
					y2="887.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.56"
					y1="890.91"
					x2="158.56"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.5"
					y1="890.91"
					x2="159.5"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.56"
					y1="864.84"
					x2="158.56"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.5"
					y1="864.84"
					x2="159.5"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.73"
					y1="886.69"
					x2="178.26"
					y2="886.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.26"
					y1="886.69"
					x2="178.26"
					y2="883.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.26"
					y1="883.81"
					x2="181.73"
					y2="883.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.73"
					y1="869.07"
					x2="178.26"
					y2="869.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.26"
					y1="869.07"
					x2="178.26"
					y2="871.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.26"
					y1="871.94"
					x2="181.73"
					y2="871.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.82"
					y1="857.55"
					x2="159.19"
					y2="857.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.82"
					y1="855.51"
					x2="159.19"
					y2="855.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.19"
					y1="855.51"
					x2="159.19"
					y2="857.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.82"
					y1="855.51"
					x2="167.82"
					y2="857.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.16"
					y1="877.88"
					x2="226.8"
					y2="880.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.8"
					y1="880.99"
					x2="226"
					y2="884.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226"
					y1="884.01"
					x2="224.47"
					y2="887.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.47"
					y1="887.21"
					x2="221.94"
					y2="890.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.94"
					y1="890.17"
					x2="218.75"
					y2="892.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.75"
					y1="892.4"
					x2="215.13"
					y2="894.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.13"
					y1="894.05"
					x2="211.28"
					y2="895.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.28"
					y1="895.25"
					x2="205.07"
					y2="896.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.07"
					y1="896.33"
					x2="201.93"
					y2="896.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.93"
					y1="896.39"
					x2="198.81"
					y2="896.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.81"
					y1="896.04"
					x2="193.96"
					y2="894.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.96"
					y1="894.62"
					x2="189.27"
					y2="892.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.27"
					y1="892.43"
					x2="185.08"
					y2="889.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.08"
					y1="889.82"
					x2="181.73"
					y2="887.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.71"
					y1="894.11"
					x2="188.36"
					y2="894.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.36"
					y1="894.14"
					x2="184.12"
					y2="894.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.12"
					y1="894.85"
					x2="181.84"
					y2="895.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.84"
					y1="895.59"
					x2="179.58"
					y2="896.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.58"
					y1="896.65"
					x2="176.3"
					y2="898.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.3"
					y1="898.75"
					x2="172.89"
					y2="900.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.89"
					y1="900.6"
					x2="169.57"
					y2="901.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.57"
					y1="901.34"
					x2="166.26"
					y2="901.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.26"
					y1="901.06"
					x2="163.25"
					y2="899.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="163.25"
					y1="899.77"
					x2="161.95"
					y2="898.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.95"
					y1="898.75"
					x2="160.83"
					y2="897.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.83"
					y1="897.49"
					x2="159.6"
					y2="895.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.6"
					y1="895.27"
					x2="158.91"
					y2="893.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.91"
					y1="893.14"
					x2="158.56"
					y2="890.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.5"
					y1="890.91"
					x2="159.59"
					y2="891.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.59"
					y1="891.91"
					x2="160.23"
					y2="893.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.23"
					y1="893.96"
					x2="161.76"
					y2="895.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.76"
					y1="895.77"
					x2="163.88"
					y2="896.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="163.88"
					y1="896.9"
					x2="166.68"
					y2="897.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.68"
					y1="897.44"
					x2="169.56"
					y2="897.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.56"
					y1="897.57"
					x2="171"
					y2="897.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171"
					y1="897.55"
					x2="172.13"
					y2="896.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.13"
					y1="896.95"
					x2="172.47"
					y2="896.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.47"
					y1="896.24"
					x2="174.71"
					y2="888.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.71"
					y1="888.36"
					x2="175.37"
					y2="884.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.37"
					y1="884.43"
					x2="175.66"
					y2="880.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.66"
					y1="880.47"
					x2="175.66"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.77"
					y1="861.62"
					x2="188.41"
					y2="861.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.41"
					y1="861.59"
					x2="184.15"
					y2="860.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.15"
					y1="860.87"
					x2="181.86"
					y2="860.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.86"
					y1="860.15"
					x2="179.58"
					y2="859.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.58"
					y1="859.11"
					x2="176.29"
					y2="857.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.29"
					y1="857.02"
					x2="172.89"
					y2="855.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.89"
					y1="855.16"
					x2="170.68"
					y2="854.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.68"
					y1="854.55"
					x2="168.4"
					y2="854.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="168.4"
					y1="854.4"
					x2="166.16"
					y2="854.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.16"
					y1="854.73"
					x2="164.07"
					y2="855.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.5"
					y1="864.84"
					x2="159.59"
					y2="863.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.59"
					y1="863.85"
					x2="160.23"
					y2="861.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.23"
					y1="861.8"
					x2="161.76"
					y2="859.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.76"
					y1="859.99"
					x2="163.88"
					y2="858.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="163.88"
					y1="858.85"
					x2="166.68"
					y2="858.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.68"
					y1="858.31"
					x2="169.56"
					y2="858.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.56"
					y1="858.19"
					x2="171"
					y2="858.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171"
					y1="858.21"
					x2="172.13"
					y2="858.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.13"
					y1="858.81"
					x2="172.47"
					y2="859.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.47"
					y1="859.51"
					x2="174.71"
					y2="867.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.71"
					y1="867.4"
					x2="175.37"
					y2="871.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.37"
					y1="871.32"
					x2="175.66"
					y2="875.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.66"
					y1="875.29"
					x2="175.66"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.16"
					y1="877.88"
					x2="226.8"
					y2="874.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.8"
					y1="874.76"
					x2="226"
					y2="871.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226"
					y1="871.75"
					x2="224.47"
					y2="868.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.47"
					y1="868.54"
					x2="221.94"
					y2="865.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.94"
					y1="865.59"
					x2="218.75"
					y2="863.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.75"
					y1="863.35"
					x2="215.13"
					y2="861.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.13"
					y1="861.71"
					x2="211.28"
					y2="860.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.28"
					y1="860.51"
					x2="205.07"
					y2="859.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.07"
					y1="859.43"
					x2="201.93"
					y2="859.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.93"
					y1="859.37"
					x2="198.81"
					y2="859.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.81"
					y1="859.72"
					x2="193.96"
					y2="861.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.96"
					y1="861.13"
					x2="189.27"
					y2="863.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.27"
					y1="863.33"
					x2="185.08"
					y2="865.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.08"
					y1="865.94"
					x2="181.73"
					y2="868.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.7"
					y1="899.73"
					x2="175.41"
					y2="899.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.41"
					y1="899.22"
					x2="176.47"
					y2="897.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.47"
					y1="897.79"
					x2="176.72"
					y2="896.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.72"
					y1="896.55"
					x2="177.4"
					y2="888.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.4"
					y1="888.54"
					x2="177.71"
					y2="880.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.71"
					y1="880.51"
					x2="177.71"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.7"
					y1="856.03"
					x2="175.41"
					y2="856.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.41"
					y1="856.53"
					x2="176.47"
					y2="857.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.47"
					y1="857.97"
					x2="176.72"
					y2="859.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.72"
					y1="859.21"
					x2="177.4"
					y2="867.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.4"
					y1="867.22"
					x2="177.71"
					y2="875.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.71"
					y1="875.25"
					x2="177.71"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.41"
					y1="857.55"
					x2="160.83"
					y2="858.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.83"
					y1="858.27"
					x2="159.6"
					y2="860.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.6"
					y1="860.49"
					x2="158.91"
					y2="862.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.91"
					y1="862.62"
					x2="158.56"
					y2="864.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="209.4 840.33 209.4 769.27 158.56 769.27 158.56 840.33 209.4 840.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="209.4"
					y1="840.33"
					x2="209.4"
					y2="769.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.56"
					y1="840.33"
					x2="158.56"
					y2="769.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.4"
					y1="769.27"
					x2="158.56"
					y2="769.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.4"
					y1="840.33"
					x2="158.56"
					y2="840.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.54"
					y1="840.33"
					x2="160.54"
					y2="769.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.16"
					y1="829.9"
					x2="197.16"
					y2="779.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.16"
					y1="779.71"
					x2="167.04"
					y2="779.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.04"
					y1="779.71"
					x2="167.04"
					y2="829.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.04"
					y1="829.9"
					x2="197.16"
					y2="829.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.13"
					y1="831.88"
					x2="199.13"
					y2="777.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.13"
					y1="777.73"
					x2="165.06"
					y2="777.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.06"
					y1="777.73"
					x2="165.06"
					y2="831.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.06"
					y1="831.88"
					x2="199.13"
					y2="831.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m176.8,804.8c0-1.64-1.33-2.96-2.96-2.96s-2.96,1.33-2.96,2.96,1.33,2.96,2.96,2.96,2.96-1.33,2.96-2.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="161.12 807.27 165.27 806.88 166.21 806.55 171.44 805.9 172.13 805.54 172.41 804.8 172.13 804.07 171.44 803.71 166.21 803.05 165.27 802.73 161.12 802.33 159.67 802.8 158.77 804.04 158.77 805.56 159.67 806.8 161.12 807.27"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m161.12,807.27c-1.36,0-2.47-1.11-2.47-2.47s1.11-2.47,2.47-2.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.27"
					y1="802.73"
					x2="161.12"
					y2="802.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m165.27,802.73c.33.03.66.14.94.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.44"
					y1="803.71"
					x2="166.21"
					y2="803.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m171.44,803.71c.55.07.97.54.97,1.1s-.41,1.03-.97,1.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.21"
					y1="806.55"
					x2="171.44"
					y2="805.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m166.21,806.55c-.28.18-.61.3-.94.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.12"
					y1="807.27"
					x2="165.27"
					y2="806.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="163.59"
					y1="803.46"
					x2="165.05"
					y2="803.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.05"
					y1="806.15"
					x2="163.59"
					y2="806.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="163.59"
					y1="806.15"
					x2="163.59"
					y2="803.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m165.05,803.46c.74,0,1.34.6,1.34,1.35s-.6,1.35-1.34,1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m166.21,803.05c.6.38.96,1.04.96,1.75s-.36,1.37-.96,1.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="158.56 908 159.56 908 159.56 902.98 158.56 902.98 158.56 908"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="158.56"
					y1="902.98"
					x2="158.56"
					y2="908"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.56"
					y1="902.98"
					x2="158.56"
					y2="902.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.56"
					y1="908"
					x2="159.56"
					y2="902.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.56"
					y1="908"
					x2="159.56"
					y2="908"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="158.56 847.76 158.56 852.78 159.56 852.78 159.56 847.76 158.56 847.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="159.56"
					y1="847.76"
					x2="158.56"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.56"
					y1="852.78"
					x2="159.56"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.56"
					y1="852.78"
					x2="159.56"
					y2="852.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.56"
					y1="847.76"
					x2="158.56"
					y2="852.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="159.56 905.99 167.73 905.99 167.73 904.99 159.56 904.99 159.56 905.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="159.56"
					y1="904.99"
					x2="159.56"
					y2="905.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.73"
					y1="904.99"
					x2="159.56"
					y2="904.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.73"
					y1="905.99"
					x2="167.73"
					y2="904.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.56"
					y1="905.99"
					x2="167.73"
					y2="905.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="159.56 849.77 159.56 850.77 167.73 850.77 167.73 849.77 159.56 849.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="167.73"
					y1="849.77"
					x2="159.56"
					y2="849.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.73"
					y1="850.77"
					x2="167.73"
					y2="849.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.56"
					y1="850.77"
					x2="167.73"
					y2="850.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.56"
					y1="849.77"
					x2="159.56"
					y2="850.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="165.22 904.99 167.23 904.99 167.23 850.77 165.22 850.77 165.22 904.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="165.22"
					y1="850.77"
					x2="165.22"
					y2="904.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.23"
					y1="850.77"
					x2="165.22"
					y2="850.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.23"
					y1="904.99"
					x2="167.23"
					y2="850.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.22"
					y1="904.99"
					x2="167.23"
					y2="904.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.15"
					y1="690.34"
					x2="172.58"
					y2="690.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.58"
					y1="769.27"
					x2="327.15"
					y2="769.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.58"
					y1="690.34"
					x2="172.58"
					y2="769.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="182.26 699.69 182.26 758.89 316.8 758.89 316.8 699.69 182.26 699.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="316.8"
					y1="699.69"
					x2="182.26"
					y2="699.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.8"
					y1="758.89"
					x2="316.8"
					y2="699.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.26"
					y1="758.89"
					x2="316.8"
					y2="758.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.26"
					y1="699.69"
					x2="182.26"
					y2="758.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="195.48 729.81 195.44 729.28 195.3 728.76 195.09 728.28 194.79 727.84 194.43 727.46 194.01 727.16 193.54 726.93 193.04 726.79 192.53 726.75 192.02 726.79 191.52 726.93 191.05 727.16 190.63 727.46 190.27 727.84 189.97 728.28 189.76 728.76 189.62 729.28 189.58 729.81 189.62 730.34 189.76 730.85 189.97 731.34 190.27 731.78 190.63 732.15 191.05 732.46 191.52 732.68 192.02 732.82 192.53 732.87 193.04 732.82 193.54 732.68 194.01 732.46 194.43 732.15 194.79 731.78 195.09 731.34 195.3 730.85 195.44 730.34 195.48 729.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="195.44"
					y1="730.34"
					x2="195.48"
					y2="729.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.3"
					y1="730.85"
					x2="195.44"
					y2="730.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.09"
					y1="731.34"
					x2="195.3"
					y2="730.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.79"
					y1="731.78"
					x2="195.09"
					y2="731.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.43"
					y1="732.15"
					x2="194.79"
					y2="731.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.01"
					y1="732.46"
					x2="194.43"
					y2="732.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.54"
					y1="732.68"
					x2="194.01"
					y2="732.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.04"
					y1="732.82"
					x2="193.54"
					y2="732.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.53"
					y1="732.87"
					x2="193.04"
					y2="732.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.02"
					y1="732.82"
					x2="192.53"
					y2="732.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.52"
					y1="732.68"
					x2="192.02"
					y2="732.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.05"
					y1="732.46"
					x2="191.52"
					y2="732.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.63"
					y1="732.15"
					x2="191.05"
					y2="732.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.27"
					y1="731.78"
					x2="190.63"
					y2="732.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.97"
					y1="731.34"
					x2="190.27"
					y2="731.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.76"
					y1="730.85"
					x2="189.97"
					y2="731.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.62"
					y1="730.34"
					x2="189.76"
					y2="730.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.58"
					y1="729.81"
					x2="189.62"
					y2="730.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.62"
					y1="729.28"
					x2="189.58"
					y2="729.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.76"
					y1="728.76"
					x2="189.62"
					y2="729.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.97"
					y1="728.28"
					x2="189.76"
					y2="728.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.27"
					y1="727.84"
					x2="189.97"
					y2="728.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.63"
					y1="727.46"
					x2="190.27"
					y2="727.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.05"
					y1="727.16"
					x2="190.63"
					y2="727.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.52"
					y1="726.93"
					x2="191.05"
					y2="727.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.02"
					y1="726.79"
					x2="191.52"
					y2="726.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.53"
					y1="726.75"
					x2="192.02"
					y2="726.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.04"
					y1="726.79"
					x2="192.53"
					y2="726.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.54"
					y1="726.93"
					x2="193.04"
					y2="726.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.01"
					y1="727.16"
					x2="193.54"
					y2="726.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.43"
					y1="727.46"
					x2="194.01"
					y2="727.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.79"
					y1="727.84"
					x2="194.43"
					y2="727.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.09"
					y1="728.28"
					x2="194.79"
					y2="727.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.3"
					y1="728.76"
					x2="195.09"
					y2="728.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.44"
					y1="729.28"
					x2="195.3"
					y2="728.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.48"
					y1="729.81"
					x2="195.44"
					y2="729.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="178.81 732.45 178.36 732.41 177.94 732.29 177.53 732.1 177.17 731.83 176.86 731.5 176.6 731.13 176.41 730.71 176.3 730.27 176.26 729.81 176.3 729.35 176.41 728.9 176.6 728.49 176.86 728.11 177.17 727.79 177.53 727.52 177.94 727.33 178.36 727.21 178.81 727.17 183.08 727.59 183.42 727.65 183.75 727.77 184.05 727.94 189.44 728.64 189.63 728.68 189.81 728.75 189.98 728.86 190.12 728.99 190.24 729.15 190.34 729.32 190.4 729.51 190.44 729.71 190.44 729.91 190.4 730.11 190.34 730.29 190.24 730.47 190.12 730.63 189.98 730.76 189.81 730.86 189.63 730.94 189.44 730.98 184.05 731.68 183.75 731.85 183.42 731.96 183.08 732.03 178.81 732.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="178.81"
					y1="732.45"
					x2="183.08"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.05"
					y1="731.68"
					x2="189.44"
					y2="730.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.44"
					y1="728.64"
					x2="184.05"
					y2="727.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.08"
					y1="727.59"
					x2="178.81"
					y2="727.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.34"
					y1="728.37"
					x2="182.86"
					y2="728.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.86"
					y1="731.25"
					x2="181.34"
					y2="731.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.34"
					y1="731.25"
					x2="181.34"
					y2="728.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m184.05,731.68c-.29.2-.62.31-.97.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m189.44,728.64c.57.07,1,.58,1,1.17s-.43,1.1-1,1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m183.08,727.59c.35.03.68.15.97.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m178.81,732.45c-1.41,0-2.55-1.18-2.55-2.64s1.14-2.64,2.55-2.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m182.86,728.37c.77,0,1.39.64,1.39,1.43s-.62,1.44-1.39,1.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m184.05,727.94c.61.41.99,1.11.99,1.87s-.37,1.46-.99,1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.94"
					y1="606.19"
					x2="844.7"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.08"
					y1="606.19"
					x2="835.06"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.45"
					y1="606.19"
					x2="825.42"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.81"
					y1="606.19"
					x2="815.79"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.17"
					y1="606.19"
					x2="806.15"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.53"
					y1="606.19"
					x2="796.51"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.9"
					y1="606.19"
					x2="790.66"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.94"
					y1="663.46"
					x2="846.94"
					y2="660.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.94"
					y1="657.11"
					x2="846.94"
					y2="651.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.94"
					y1="647.47"
					x2="846.94"
					y2="641.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.94"
					y1="637.83"
					x2="846.94"
					y2="631.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.94"
					y1="628.2"
					x2="846.94"
					y2="622.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.94"
					y1="618.56"
					x2="846.94"
					y2="612.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.94"
					y1="608.92"
					x2="846.94"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="663.46"
					x2="792.9"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.51"
					y1="663.46"
					x2="802.53"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.79"
					y1="663.46"
					x2="821.81"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.42"
					y1="663.46"
					x2="831.45"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.06"
					y1="663.46"
					x2="841.08"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.7"
					y1="663.46"
					x2="846.94"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="606.19"
					x2="790.66"
					y2="608.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="612.53"
					x2="790.66"
					y2="618.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="622.17"
					x2="790.66"
					y2="628.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="631.81"
					x2="790.66"
					y2="637.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="641.45"
					x2="790.66"
					y2="647.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="651.09"
					x2="790.66"
					y2="657.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="660.72"
					x2="790.66"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="846.72 603.22 846.72 601.49 790.87 601.49 790.87 603.22 799.63 603.22 799.63 601.81 837.96 601.81 837.96 603.22 846.72 603.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="837.96"
					y1="603.22"
					x2="846.72"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="837.96"
					y1="601.81"
					x2="837.96"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="799.63"
					y1="601.81"
					x2="837.96"
					y2="601.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="799.63"
					y1="603.22"
					x2="799.63"
					y2="601.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="790.87"
					y1="603.22"
					x2="799.63"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="790.87"
					y1="601.49"
					x2="790.87"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="846.72"
					y1="601.49"
					x2="790.87"
					y2="601.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="846.72"
					y1="603.22"
					x2="846.72"
					y2="601.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<polyline
					points="848.92 603.22 788.68 603.22 788.68 606.19 848.92 606.19 848.92 603.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="848.92"
					y1="606.19"
					x2="848.92"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="788.68"
					y1="606.19"
					x2="848.92"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="788.68"
					y1="603.22"
					x2="788.68"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="848.92"
					y1="603.22"
					x2="788.68"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="790.87"
					y1="603.22"
					x2="790.87"
					y2="601.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.87"
					y1="601.49"
					x2="846.72"
					y2="601.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.72"
					y1="601.49"
					x2="846.72"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.68"
					y1="603.22"
					x2="848.92"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.96"
					y1="603.22"
					x2="837.96"
					y2="601.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.96"
					y1="601.81"
					x2="799.63"
					y2="601.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.63"
					y1="601.81"
					x2="799.63"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.68"
					y1="606.19"
					x2="788.68"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.92"
					y1="603.22"
					x2="848.92"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.92"
					y1="606.19"
					x2="788.68"
					y2="606.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="613.22 594.49 530.46 594.49 530.46 686.76 613.22 686.76 613.22 594.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="613.22"
					y1="686.76"
					x2="613.22"
					y2="594.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.46"
					y1="686.76"
					x2="613.22"
					y2="686.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.46"
					y1="594.49"
					x2="530.46"
					y2="686.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.22"
					y1="594.49"
					x2="530.46"
					y2="594.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.22"
					y1="600.76"
					x2="530.46"
					y2="600.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="713.21 598.2 637.91 598.2 637.91 663.46 713.21 663.46 713.21 598.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="713.21"
					y1="598.2"
					x2="637.91"
					y2="598.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.21"
					y1="663.46"
					x2="637.91"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.21"
					y1="661.48"
					x2="637.91"
					y2="661.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.21"
					y1="598.2"
					x2="713.21"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.91"
					y1="598.2"
					x2="637.91"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.27"
					y1="601.17"
					x2="642.85"
					y2="601.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.85"
					y1="601.17"
					x2="640.88"
					y2="603.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.88"
					y1="603.14"
					x2="640.88"
					y2="658.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.88"
					y1="658.52"
					x2="642.85"
					y2="660.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.85"
					y1="660.49"
					x2="708.27"
					y2="660.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.27"
					y1="660.49"
					x2="710.24"
					y2="658.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.24"
					y1="658.52"
					x2="710.24"
					y2="603.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.24"
					y1="603.14"
					x2="708.27"
					y2="601.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m704.27,614.52c0-5.46-4.42-9.88-9.88-9.88s-9.88,4.42-9.88,9.88,4.43,9.88,9.88,9.88,9.88-4.42,9.88-9.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m701.8,647.14c0-4.09-3.32-7.41-7.41-7.41s-7.41,3.32-7.41,7.41,3.32,7.41,7.41,7.41,7.41-3.32,7.41-7.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m664.15,614.52c0-4.09-3.32-7.41-7.41-7.41s-7.41,3.32-7.41,7.41,3.32,7.41,7.41,7.41,7.41-3.32,7.41-7.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m666.62,647.14c0-5.46-4.42-9.88-9.88-9.88s-9.88,4.42-9.88,9.88,4.42,9.88,9.88,9.88,9.88-4.42,9.88-9.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="776.63 608.24 723.91 608.24 722.92 608.51 722.19 609.23 721.93 610.22 721.93 661.48 722.19 662.47 722.92 663.19 723.91 663.46 776.63 663.46 777.62 663.19 778.34 662.47 778.6 661.48 778.6 610.22 778.34 609.23 777.62 608.51 776.63 608.24"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m776.63,608.24c1.09,0,1.98.89,1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.6"
					y1="661.48"
					x2="778.6"
					y2="610.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m778.6,661.48c0,1.09-.88,1.98-1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.91"
					y1="663.46"
					x2="776.63"
					y2="663.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m723.91,663.46c-1.09,0-1.98-.88-1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.93"
					y1="610.22"
					x2="721.93"
					y2="661.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m721.93,610.22c0-1.09.89-1.98,1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.63"
					y1="608.24"
					x2="723.91"
					y2="608.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.69"
					y1="613.18"
					x2="728.85"
					y2="613.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.87"
					y1="615.16"
					x2="726.87"
					y2="651.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.85"
					y1="653.58"
					x2="771.69"
					y2="653.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.67"
					y1="651.6"
					x2="773.67"
					y2="615.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.69"
					y1="613.18"
					x2="771.69"
					y2="613.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m726.87,615.16c0-1.09.88-1.98,1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m728.85,653.58c-1.09,0-1.98-.89-1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m773.67,651.6c0,1.09-.89,1.98-1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m771.69,613.18c1.09,0,1.98.89,1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m753.23,643.7c0-1.64-1.33-2.96-2.96-2.96s-2.96,1.33-2.96,2.96,1.33,2.96,2.96,2.96,2.96-1.33,2.96-2.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.16 640.94 750.9 640.31 750.27 640.05 749.64 640.31 749.38 640.94 749.38 660.49 749.64 661.12 750.27 661.38 750.9 661.12 751.16 660.49 751.16 640.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="751.16"
					y1="660.49"
					x2="751.16"
					y2="640.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m751.16,660.49c0,.49-.4.89-.89.89s-.89-.4-.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.38"
					y1="640.94"
					x2="749.38"
					y2="660.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m749.38,640.94h0c0-.49.4-.89.89-.89s.89.4.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="752.24 655.45 751.16 655.45 751.16 660.49 750.9 661.12 750.27 661.38 749.64 661.12 749.38 660.49 749.38 655.45 748.29 655.45 748.29 661.88 752.24 661.88 752.24 655.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="752.24"
					y1="661.88"
					x2="752.24"
					y2="655.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.29"
					y1="661.88"
					x2="752.24"
					y2="661.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.29"
					y1="655.45"
					x2="748.29"
					y2="661.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.38"
					y1="655.45"
					x2="748.29"
					y2="655.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.38"
					y1="660.49"
					x2="749.38"
					y2="655.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m751.16,660.49c0,.49-.4.89-.89.89s-.89-.4-.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.16"
					y1="655.45"
					x2="751.16"
					y2="660.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.24"
					y1="655.45"
					x2="751.16"
					y2="655.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="752.21 651.9 751.16 651.9 751.16 655.36 752.21 655.36 752.21 651.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="752.21"
					y1="655.36"
					x2="752.21"
					y2="651.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.16"
					y1="655.36"
					x2="752.21"
					y2="655.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.16"
					y1="651.9"
					x2="751.16"
					y2="655.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.21"
					y1="651.9"
					x2="751.16"
					y2="651.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="748.32 651.9 748.32 655.36 749.38 655.36 749.38 651.9 748.32 651.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="749.38"
					y1="651.9"
					x2="748.32"
					y2="651.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.38"
					y1="655.36"
					x2="749.38"
					y2="651.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.32"
					y1="655.36"
					x2="749.38"
					y2="655.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.32"
					y1="651.9"
					x2="748.32"
					y2="655.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.97"
					y1="636.78"
					x2="237.54"
					y2="636.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.54"
					y1="636.78"
					x2="237.54"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.97"
					y1="646.82"
					x2="219.97"
					y2="579.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.79"
					y1="579.05"
					x2="174.79"
					y2="646.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.79"
					y1="646.82"
					x2="242.56"
					y2="646.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.56"
					y1="579.05"
					x2="174.79"
					y2="579.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.3"
					y1="646.82"
					x2="241.3"
					y2="579.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.97"
					y1="589.09"
					x2="237.54"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.56"
					y1="646.82"
					x2="242.56"
					y2="579.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.44"
					y1="594.49"
					x2="540.44"
					y2="589.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.44"
					y1="589.53"
					x2="542.95"
					y2="589.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.95"
					y1="589.53"
					x2="542.95"
					y2="594.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.22"
					y1="603.22"
					x2="607.38"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.76"
					y1="603.22"
					x2="597.74"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.13"
					y1="603.22"
					x2="588.1"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.49"
					y1="603.22"
					x2="578.47"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.85"
					y1="603.22"
					x2="568.83"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.21"
					y1="603.22"
					x2="559.19"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.57"
					y1="603.22"
					x2="549.55"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.94"
					y1="603.22"
					x2="539.92"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.3"
					y1="603.22"
					x2="530.46"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.67"
					y1="633.34"
					x2="849.8"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.29"
					y1="633.34"
					x2="840.26"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.65"
					y1="633.34"
					x2="830.63"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="827.02"
					y1="633.34"
					x2="820.99"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.38"
					y1="633.34"
					x2="811.35"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.74"
					y1="633.34"
					x2="801.72"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.1"
					y1="633.34"
					x2="792.08"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.46"
					y1="633.34"
					x2="782.44"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.83"
					y1="633.34"
					x2="772.8"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="633.34"
					x2="763.17"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.55"
					y1="633.34"
					x2="753.53"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.91"
					y1="633.34"
					x2="743.89"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.28"
					y1="633.34"
					x2="734.25"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.64"
					y1="633.34"
					x2="724.61"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721"
					y1="633.34"
					x2="714.98"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.36"
					y1="633.34"
					x2="705.34"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.72"
					y1="633.34"
					x2="695.7"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.09"
					y1="633.34"
					x2="686.07"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.45"
					y1="633.34"
					x2="676.43"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.81"
					y1="633.34"
					x2="666.79"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.18"
					y1="633.34"
					x2="657.15"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.54"
					y1="633.34"
					x2="647.51"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.9"
					y1="633.34"
					x2="637.88"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.26"
					y1="633.34"
					x2="628.24"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.62"
					y1="633.34"
					x2="618.6"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.09"
					y1="633.34"
					x2="613.22"
					y2="633.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.67"
					y1="603.22"
					x2="713.21"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.91"
					y1="603.22"
					x2="613.22"
					y2="603.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.16"
					y1="52.42"
					x2="385.46"
					y2="52.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.46"
					y1="72.5"
					x2="217.16"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.72"
					y1="52.42"
					x2="716.9"
					y2="52.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.9"
					y1="72.5"
					x2="522.72"
					y2="72.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.32"
					y1="636.78"
					x2="182.32"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.32"
					y1="589.09"
					x2="214.95"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.95"
					y1="589.09"
					x2="214.95"
					y2="636.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.95"
					y1="636.78"
					x2="182.32"
					y2="636.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="398.51 926.25 398.51 946.33 138.48 946.33 138.48 749.2 152.5 749.2 152.5 621.18 128.25 621.18 128.25 52.42 217.16 52.42 217.16 72.5 148.33 72.5 148.33 474.85 176.51 474.85 176.51 487.4 148.33 487.4 148.33 543.95 280 543.95 280 487.4 256.82 487.4 256.82 474.85 322.63 474.85 322.63 487.4 292.55 487.4 292.55 556.49 257.8 556.49 257.8 574.76 245.25 574.76 245.25 556.49 148.33 556.49 148.33 601.1 172.58 601.1 172.58 677.8 245.25 677.8 245.25 655.08 257.8 655.08 257.8 677.8 339.7 677.8 339.7 832.46 327.15 832.46 327.15 690.34 172.58 690.34 172.58 769.27 158.56 769.27 158.56 926.25 327.15 926.25 327.15 912.78 339.7 912.78 339.7 926.25 398.51 926.25"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<polygon
					points="522.72 52.42 522.72 72.5 490.15 72.5 490.15 157.56 462.37 157.56 462.37 305.36 480.25 305.36 480.25 445.67 462.37 445.67 462.37 487.4 402.94 487.4 402.94 474.85 449.82 474.85 449.82 445.67 419.5 445.67 419.5 305.36 449.82 305.36 449.82 157.56 419.24 157.56 419.24 72.5 385.46 72.5 385.46 52.42 522.72 52.42"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<polygon
					points="871.75 89.67 871.75 706.84 523.4 706.84 523.4 946.33 493.88 946.33 493.88 926.25 503.32 926.25 503.32 686.76 613.22 686.76 613.22 663.46 851.67 663.46 851.67 89.67 851.08 85.22 849.37 81.08 846.64 77.53 843.08 74.8 838.94 73.08 834.5 72.5 716.9 72.5 716.9 52.42 834.5 52.42 840.97 52.98 847.24 54.67 853.12 57.41 858.44 61.13 863.03 65.72 866.76 71.04 869.5 76.93 871.18 83.2 871.75 89.67"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
			</g>
			<g id="text">
				<path d="m806.5,627.67v-11.64h4.01c.91,0,1.6.06,2.07.17.67.15,1.24.43,1.71.83.61.52,1.07,1.18,1.37,1.99.31.8.46,1.73.46,2.76,0,.88-.1,1.67-.31,2.35-.21.68-.47,1.25-.79,1.7-.32.44-.68.8-1.06,1.06-.38.25-.84.45-1.39.58-.54.13-1.16.2-1.87.2h-4.2Zm1.54-1.37h2.49c.77,0,1.37-.07,1.8-.21.44-.14.79-.34,1.05-.6.37-.37.65-.86.85-1.47.21-.62.31-1.37.31-2.25,0-1.22-.2-2.15-.6-2.8-.4-.66-.88-1.1-1.45-1.32-.41-.16-1.08-.24-1.99-.24h-2.45v8.89Zm12.24,1.37l-3.09-11.64h1.58l1.77,7.63c.19.8.35,1.59.49,2.38.3-1.24.47-1.96.52-2.15l2.22-7.86h1.86l1.67,5.89c.42,1.46.72,2.84.91,4.12.15-.74.34-1.58.58-2.53l1.83-7.48h1.55l-3.19,11.64h-1.49l-2.45-8.87c-.21-.74-.33-1.2-.37-1.37-.12.53-.24.99-.34,1.37l-2.47,8.87h-1.57Z" />
				<path d="m568.17,647.6h-1.64l-1.96-3.29c-.18-.31-.35-.56-.52-.78-.17-.22-.34-.4-.52-.53-.17-.14-.37-.23-.57-.29-.2-.07-.43-.1-.69-.1h-1.13v4.99h-1.37v-11.72h3.5c.51,0,.98.07,1.41.2.44.13.81.32,1.13.58.32.26.57.59.75.98.18.39.27.84.27,1.37,0,.41-.06.78-.19,1.13-.12.34-.29.64-.52.91-.22.27-.5.5-.82.69-.32.19-.67.33-1.07.43v.03c.2.09.37.19.51.3.15.11.29.24.42.39.13.15.26.33.38.52.13.19.28.41.43.67l2.2,3.52Zm-7.03-10.48v4.25h1.86c.34,0,.66-.05.95-.16.29-.1.55-.25.76-.44.21-.2.38-.43.5-.71.12-.28.18-.6.18-.95,0-.63-.2-1.11-.61-1.46-.4-.35-.99-.53-1.76-.53h-1.88Zm15.03,6.63h-5.91c.02.93.27,1.65.75,2.16s1.14.76,1.98.76c.94,0,1.81-.31,2.6-.93v1.26c-.74.53-1.71.8-2.92.8s-2.11-.38-2.79-1.14c-.68-.76-1.01-1.83-1.01-3.21,0-1.3.37-2.36,1.1-3.18.74-.82,1.66-1.23,2.76-1.23s1.94.35,2.54,1.06c.6.71.9,1.69.9,2.95v.7Zm-1.37-1.14c0-.77-.19-1.38-.56-1.81-.37-.43-.87-.65-1.53-.65s-1.17.23-1.61.68c-.44.45-.71,1.04-.82,1.77h4.52Zm7.38-6.23c-.26-.15-.56-.22-.89-.22-.94,0-1.41.59-1.41,1.77v1.29h1.96v1.14h-1.96v7.23h-1.33v-7.23h-1.43v-1.14h1.43v-1.36c0-.88.25-1.57.76-2.08.51-.51,1.14-.77,1.9-.77.41,0,.73.05.97.15v1.21Z" />
				<path d="m583.6,647.78c-.25,0-.47-.09-.65-.27-.17-.18-.26-.4-.26-.65s.09-.47.26-.65c.18-.19.4-.28.65-.28s.47.09.65.28c.18.18.27.4.27.65s-.09.47-.27.65-.4.27-.65.27Z" />
				<path d="m244.6,823.64v-18.19h5.18c1.57,0,2.82.38,3.74,1.15.92.77,1.38,1.77,1.38,3.01,0,1.03-.28,1.93-.84,2.69-.56.76-1.33,1.3-2.31,1.62v.05c1.23.14,2.21.61,2.94,1.4.74.78,1.1,1.79,1.1,3.04,0,1.56-.56,2.82-1.67,3.78s-2.52,1.45-4.22,1.45h-5.3Zm2.13-16.26v5.87h2.18c1.17,0,2.08-.28,2.75-.84.67-.57,1-1.36,1-2.38,0-1.77-1.16-2.65-3.49-2.65h-2.45Zm0,7.79v6.54h2.89c1.25,0,2.22-.3,2.9-.89.69-.59,1.04-1.4,1.04-2.44,0-2.15-1.46-3.22-4.39-3.22h-2.45Zm21.77,8.47h-2.08v-2.03h-.05c-.9,1.56-2.24,2.33-4,2.33-1.29,0-2.31-.34-3.04-1.03-.73-.68-1.09-1.59-1.09-2.73,0-2.43,1.43-3.84,4.29-4.24l3.89-.55c0-2.21-.89-3.31-2.68-3.31-1.56,0-2.98.53-4.24,1.6v-2.13c1.28-.81,2.75-1.22,4.41-1.22,3.05,0,4.58,1.62,4.58,4.85v8.45Zm-2.08-6.57l-3.13.43c-.96.14-1.69.38-2.18.72-.49.34-.74.94-.74,1.81,0,.63.22,1.15.67,1.56.46.4,1.06.6,1.81.6,1.03,0,1.88-.36,2.55-1.08.68-.73,1.01-1.64,1.01-2.75v-1.29Zm12.03,6.44c-.49.27-1.14.41-1.94.41-2.27,0-3.41-1.27-3.41-3.81v-7.69h-2.23v-1.78h2.23v-3.17l2.08-.67v3.84h3.27v1.78h-3.27v7.32c0,.87.15,1.49.44,1.86.3.37.79.56,1.47.56.52,0,.98-.14,1.36-.43v1.78Zm13.56.13h-2.08v-7.48c0-2.71-1.01-4.06-3.02-4.06-1.01,0-1.87.39-2.56,1.18-.69.78-1.04,1.78-1.04,3.01v7.36h-2.08v-19.23h2.08v8.4h.05c1-1.64,2.42-2.46,4.26-2.46,2.93,0,4.39,1.76,4.39,5.29v8Z" />
				<path d="m403.56,808.03h-9.64v-18.19h9.23v1.93h-7.1v6.05h6.57v1.92h-6.57v6.37h7.51v1.93Zm14.03,0h-2.08v-7.41c0-2.76-1.01-4.13-3.02-4.13-1.04,0-1.9.39-2.59,1.18-.68.78-1.01,1.76-1.01,2.96v7.41h-2.08v-12.99h2.08v2.16h.05c.98-1.64,2.4-2.46,4.26-2.46,1.42,0,2.51.46,3.26,1.38.75.91,1.13,2.24,1.13,3.97v7.94Zm9.97-.13c-.49.27-1.14.41-1.94.41-2.27,0-3.41-1.27-3.41-3.81v-7.69h-2.23v-1.78h2.23v-3.17l2.08-.67v3.84h3.27v1.78h-3.27v7.32c0,.87.15,1.49.44,1.86.3.37.79.56,1.47.56.52,0,.98-.14,1.36-.43v1.78Zm9.58-10.76c-.36-.28-.89-.42-1.57-.42-.89,0-1.63.42-2.23,1.26-.59.84-.89,1.98-.89,3.42v6.62h-2.08v-12.99h2.08v2.68h.05c.3-.91.75-1.62,1.36-2.13.61-.52,1.29-.77,2.04-.77.54,0,.96.06,1.24.18v2.16Zm12.63-2.11l-5.97,15.07c-1.07,2.69-2.56,4.03-4.49,4.03-.54,0-.99-.05-1.36-.16v-1.86c.45.15.86.23,1.23.23,1.05,0,1.83-.63,2.36-1.88l1.04-2.46-5.07-12.96h2.31l3.51,9.99c.04.13.13.46.27.99h.08c.04-.2.13-.52.25-.96l3.69-10.02h2.16Z" />
				<path d="m247.88,268.6v-18.19h5.18c1.57,0,2.82.38,3.74,1.15s1.38,1.77,1.38,3.01c0,1.03-.28,1.93-.84,2.69-.56.76-1.33,1.3-2.31,1.62v.05c1.23.14,2.21.61,2.94,1.4.74.78,1.1,1.79,1.1,3.04,0,1.56-.56,2.82-1.67,3.78-1.12.96-2.52,1.45-4.22,1.45h-5.3Zm2.13-16.26v5.87h2.18c1.17,0,2.08-.28,2.75-.84.67-.57,1-1.36,1-2.38,0-1.77-1.16-2.65-3.49-2.65h-2.45Zm0,7.79v6.54h2.89c1.25,0,2.22-.3,2.9-.89.69-.59,1.04-1.4,1.04-2.44,0-2.15-1.46-3.22-4.39-3.22h-2.45Zm22.9,2.5h-9.17c.03,1.45.42,2.56,1.17,3.35.74.79,1.77,1.18,3.07,1.18,1.46,0,2.81-.48,4.03-1.45v1.95c-1.14.83-2.65,1.24-4.53,1.24s-3.28-.59-4.33-1.76c-1.05-1.18-1.57-2.85-1.57-4.98,0-2.02.57-3.67,1.71-4.93,1.15-1.28,2.57-1.92,4.27-1.92s3.01.55,3.94,1.65c.93,1.1,1.4,2.63,1.4,4.58v1.09Zm-2.13-1.76c0-1.2-.3-2.14-.88-2.8-.57-.67-1.36-1-2.37-1s-1.81.35-2.5,1.05c-.68.7-1.11,1.62-1.27,2.75h7.01Zm16.35,7.74h-2.08v-2.21h-.05c-.96,1.67-2.45,2.51-4.46,2.51-1.63,0-2.94-.58-3.92-1.74-.97-1.17-1.46-2.75-1.46-4.76,0-2.15.54-3.87,1.62-5.16,1.08-1.29,2.52-1.94,4.33-1.94s3.08.7,3.89,2.11h.05v-8.04h2.08v19.23Zm-2.08-5.87v-1.92c0-1.05-.35-1.94-1.04-2.66-.69-.73-1.57-1.09-2.64-1.09-1.27,0-2.27.47-2.99,1.4s-1.09,2.22-1.09,3.86c0,1.5.35,2.68,1.04,3.55.7.86,1.64,1.29,2.82,1.29s2.1-.42,2.82-1.26c.73-.84,1.09-1.89,1.09-3.17Zm13.05-5.01c-.36-.28-.89-.42-1.57-.42-.89,0-1.63.42-2.23,1.26-.59.84-.89,1.98-.89,3.42v6.62h-2.08v-12.99h2.08v2.68h.05c.3-.91.75-1.62,1.36-2.13.61-.52,1.29-.77,2.04-.77.54,0,.96.06,1.24.18v2.16Zm7.68,11.19c-1.92,0-3.45-.6-4.6-1.81-1.14-1.22-1.71-2.83-1.71-4.83,0-2.18.6-3.89,1.79-5.11,1.19-1.23,2.8-1.84,4.83-1.84s3.45.6,4.53,1.79c1.09,1.19,1.64,2.85,1.64,4.96s-.59,3.73-1.76,4.98c-1.17,1.24-2.74,1.86-4.71,1.86Zm.15-11.85c-1.34,0-2.39.46-3.17,1.37-.78.9-1.17,2.16-1.17,3.75s.39,2.75,1.18,3.64c.79.89,1.84,1.33,3.16,1.33s2.38-.44,3.09-1.31c.73-.87,1.09-2.11,1.09-3.72s-.36-2.88-1.09-3.75c-.72-.88-1.75-1.32-3.09-1.32Zm15.05,11.85c-1.92,0-3.45-.6-4.6-1.81-1.14-1.22-1.71-2.83-1.71-4.83,0-2.18.6-3.89,1.79-5.11,1.19-1.23,2.8-1.84,4.83-1.84s3.45.6,4.53,1.79c1.09,1.19,1.64,2.85,1.64,4.96s-.59,3.73-1.76,4.98c-1.17,1.24-2.74,1.86-4.71,1.86Zm.15-11.85c-1.34,0-2.39.46-3.17,1.37-.78.9-1.17,2.16-1.17,3.75s.39,2.75,1.18,3.64c.79.89,1.84,1.33,3.16,1.33s2.38-.44,3.09-1.31c.73-.87,1.09-2.11,1.09-3.72s-.36-2.88-1.09-3.75c-.72-.88-1.75-1.32-3.09-1.32Zm28.07,11.54h-2.08v-7.46c0-1.44-.22-2.48-.67-3.12-.44-.64-1.18-.96-2.23-.96-.89,0-1.64.41-2.27,1.22-.62.81-.93,1.78-.93,2.92v7.41h-2.08v-7.71c0-2.55-.99-3.83-2.96-3.83-.91,0-1.67.38-2.26,1.15-.59.76-.89,1.75-.89,2.98v7.41h-2.08v-12.99h2.08v2.05h.05c.92-1.57,2.27-2.36,4.03-2.36.89,0,1.66.25,2.32.75.66.49,1.11,1.14,1.36,1.94.96-1.79,2.4-2.69,4.31-2.69,2.86,0,4.29,1.76,4.29,5.29v8Z" />
				<path d="m253.08,295.57h-1.51v-11.43c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.7-.4,1.02-.61.32-.22.6-.42.83-.63h.57v13.52Zm12.93-6.67c0,1.11-.1,2.09-.3,2.94-.2.85-.49,1.58-.87,2.17-.38.58-.84,1.03-1.39,1.34-.55.3-1.17.45-1.87.45-.66,0-1.26-.14-1.78-.43-.52-.3-.95-.72-1.31-1.28s-.63-1.25-.81-2.06c-.18-.82-.28-1.75-.28-2.8,0-1.16.1-2.18.29-3.06.2-.89.48-1.63.86-2.22.38-.6.84-1.05,1.39-1.36.56-.31,1.2-.46,1.92-.46,2.77,0,4.16,2.26,4.16,6.78Zm-1.55.15c0-3.76-.89-5.64-2.68-5.64-1.89,0-2.83,1.92-2.83,5.75,0,3.57.93,5.36,2.78,5.36s2.74-1.82,2.74-5.46Z" />
				<rect x="268.31" y="282.34" width="1.34" height="4.12" />
				<path d="m280.5,288.9c0,1.11-.1,2.09-.3,2.94-.2.85-.49,1.58-.87,2.17-.38.58-.84,1.03-1.39,1.34-.55.3-1.17.45-1.87.45-.66,0-1.26-.14-1.78-.43-.52-.3-.95-.72-1.31-1.28s-.63-1.25-.81-2.06c-.18-.82-.28-1.75-.28-2.8,0-1.16.1-2.18.29-3.06.2-.89.48-1.63.86-2.22.38-.6.84-1.05,1.39-1.36.56-.31,1.2-.46,1.92-.46,2.77,0,4.16,2.26,4.16,6.78Zm-1.55.15c0-3.76-.89-5.64-2.68-5.64-1.89,0-2.83,1.92-2.83,5.75,0,3.57.93,5.36,2.78,5.36s2.74-1.82,2.74-5.46Z" />
				<path d="m284.14,282.34v4.12h-1.34v-4.12h1.34Zm3.06,0v4.12h-1.34v-4.12h1.34Z" />
				<path d="m302.33,286.12l-3.17,4.78,3.12,4.67h-1.76l-1.85-3.06c-.12-.19-.26-.43-.41-.72h-.04c-.03.06-.18.3-.43.72l-1.89,3.06h-1.74l3.22-4.63-3.08-4.81h1.76l1.83,3.23c.14.24.27.49.4.74h.04l2.36-3.97h1.67Z" />
				<path d="m314.43,295.57h-1.51v-11.43c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.7-.4,1.02-.61.32-.22.6-.42.83-.63h.57v13.52Zm12.32-3.74c0,.6-.11,1.14-.34,1.63-.22.49-.54.9-.95,1.25-.41.34-.89.61-1.47.8-.57.19-1.2.29-1.89.29-1.26,0-2.26-.24-3.01-.72v-1.62c.89.7,1.91,1.05,3.06,1.05.46,0,.88-.06,1.25-.18.38-.12.69-.29.96-.51.27-.22.48-.49.62-.8.15-.31.22-.67.22-1.06,0-1.73-1.23-2.59-3.69-2.59h-1.1v-1.28h1.04c2.18,0,3.26-.81,3.26-2.43,0-1.5-.83-2.25-2.49-2.25-.93,0-1.81.31-2.63.94v-1.47c.84-.5,1.84-.76,3.01-.76.55,0,1.05.08,1.5.23.45.15.83.37,1.15.65.32.28.57.61.74,1,.18.39.27.81.27,1.28,0,1.74-.88,2.86-2.64,3.36v.04c.45.05.86.16,1.25.33.38.17.71.38.99.65.28.27.49.59.65.96.16.36.24.77.24,1.21Z" />
				<rect x="329.67" y="282.34" width="1.34" height="4.12" />
				<path d="m341.39,291.53c0,.65-.11,1.23-.33,1.75-.22.52-.54.97-.95,1.35-.41.38-.9.66-1.48.87-.58.2-1.22.3-1.93.3-1.23,0-2.14-.18-2.74-.55v-1.6c.9.58,1.82.87,2.76.87.48,0,.91-.07,1.29-.21.39-.14.72-.34.99-.59s.48-.56.62-.91c.15-.36.22-.75.22-1.17,0-.86-.29-1.53-.87-2.02-.58-.49-1.42-.74-2.52-.74-.18,0-.37,0-.56,0-.2,0-.39.02-.59.03-.2,0-.39.02-.58.03-.18.01-.35.03-.51.05l.45-6.63h6.11v1.37h-4.81l-.27,3.88c.2-.01.41-.02.63-.03.22-.01.42-.02.59-.02.7,0,1.33.09,1.88.28s1.02.45,1.4.79c.39.34.68.76.88,1.25.2.49.3,1.05.3,1.66Z" />
				<path d="m345.49,282.34v4.12h-1.34v-4.12h1.34Zm3.06,0v4.12h-1.34v-4.12h1.34Z" />
				<path d="m661.93,568.79h-2.97l-7.03-8.32c-.26-.31-.42-.52-.48-.63h-.05v8.95h-2.13v-18.19h2.13v8.55h.05c.12-.19.28-.39.48-.62l6.8-7.93h2.65l-7.8,8.73,8.35,9.46Zm3.18-16.29c-.37,0-.69-.13-.95-.38-.26-.25-.39-.58-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.41.58.41.96s-.14.69-.41.95c-.26.26-.58.39-.96.39Zm1.01,16.29h-2.08v-12.99h2.08v12.99Zm10.22-.13c-.49.27-1.14.41-1.94.41-2.27,0-3.41-1.27-3.41-3.81v-7.69h-2.23v-1.78h2.23v-3.17l2.08-.67v3.84h3.27v1.78h-3.27v7.32c0,.87.15,1.49.44,1.86.3.37.79.56,1.47.56.52,0,.98-.14,1.36-.43v1.78Zm11.62-.47c-1,.6-2.18.9-3.55.9-1.85,0-3.35-.6-4.49-1.8-1.13-1.21-1.7-2.77-1.7-4.69,0-2.14.61-3.86,1.84-5.15,1.23-1.3,2.86-1.95,4.91-1.95,1.14,0,2.15.21,3.02.63v2.13c-.96-.68-2-1.01-3.09-1.01-1.33,0-2.42.48-3.27,1.43-.85.95-1.27,2.19-1.27,3.74s.4,2.72,1.19,3.6c.8.88,1.88,1.32,3.22,1.32,1.13,0,2.2-.38,3.2-1.13v1.98Zm13.92.6h-2.08v-7.48c0-2.71-1.01-4.06-3.02-4.06-1.01,0-1.87.39-2.56,1.18-.69.78-1.04,1.78-1.04,3.01v7.36h-2.08v-19.23h2.08v8.4h.05c1-1.64,2.42-2.46,4.26-2.46,2.93,0,4.39,1.76,4.39,5.29v8Zm14.35-5.97h-9.17c.03,1.45.42,2.56,1.17,3.35.74.79,1.77,1.18,3.07,1.18,1.46,0,2.81-.48,4.03-1.45v1.95c-1.14.83-2.65,1.24-4.53,1.24s-3.28-.59-4.33-1.76c-1.05-1.18-1.57-2.85-1.57-4.98,0-2.02.57-3.67,1.71-4.93,1.15-1.28,2.57-1.92,4.27-1.92s3.01.55,3.94,1.65c.93,1.1,1.4,2.63,1.4,4.58v1.09Zm-2.13-1.76c0-1.2-.3-2.14-.88-2.8-.57-.67-1.36-1-2.37-1s-1.81.35-2.5,1.05c-.68.7-1.11,1.62-1.27,2.75h7.01Zm16.05,7.74h-2.08v-7.41c0-2.76-1.01-4.14-3.02-4.14-1.04,0-1.9.39-2.59,1.18-.68.78-1.01,1.76-1.01,2.96v7.41h-2.08v-12.99h2.08v2.16h.05c.98-1.64,2.4-2.46,4.26-2.46,1.42,0,2.51.46,3.26,1.38.75.91,1.13,2.24,1.13,3.97v7.94Z" />
				<path d="m558.61,293.33h-9.44v-18.19h2.13v16.26h7.31v1.93Zm3.58-16.29c-.37,0-.69-.13-.95-.38-.26-.25-.39-.58-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.41.58.41.96s-.14.69-.41.95c-.26.26-.58.39-.96.39Zm1.01,16.29h-2.08v-12.99h2.08v12.99Zm14.41-12.99l-5.18,12.99h-2.04l-4.92-12.99h2.28l3.3,9.44c.25.69.4,1.3.46,1.81h.05c.08-.65.22-1.24.41-1.76l3.45-9.49h2.19Zm3.29-3.3c-.37,0-.69-.13-.95-.38-.26-.25-.39-.58-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.41.58.41.96s-.14.69-.41.95c-.26.26-.58.39-.96.39Zm1.01,16.29h-2.08v-12.99h2.08v12.99Zm14.98,0h-2.08v-7.41c0-2.76-1.01-4.13-3.02-4.13-1.04,0-1.9.39-2.59,1.18-.68.78-1.01,1.76-1.01,2.96v7.41h-2.08v-12.99h2.08v2.16h.05c.98-1.64,2.4-2.46,4.26-2.46,1.42,0,2.51.46,3.26,1.38.75.91,1.13,2.24,1.13,3.97v7.94Zm15-1.04c0,4.77-2.28,7.15-6.85,7.15-1.61,0-3.01-.3-4.21-.91v-2.08c1.46.81,2.86,1.22,4.19,1.22,3.2,0,4.79-1.7,4.79-5.1v-1.42h-.05c-.99,1.66-2.48,2.49-4.46,2.49-1.62,0-2.92-.58-3.91-1.73-.98-1.16-1.47-2.71-1.47-4.65,0-2.21.53-3.96,1.59-5.26,1.07-1.3,2.52-1.95,4.36-1.95s3.05.7,3.89,2.11h.05v-1.8h2.08v11.95Zm-2.08-4.83v-1.92c0-1.03-.35-1.92-1.05-2.65-.69-.74-1.56-1.1-2.6-1.1-1.29,0-2.29.47-3.02,1.41-.73.93-1.09,2.24-1.09,3.92,0,1.45.35,2.6,1.04,3.48.7.86,1.63,1.29,2.78,1.29s2.11-.41,2.84-1.24c.74-.83,1.1-1.89,1.1-3.18Z" />
				<polygon points="624.31 275.14 615.58 296.35 613.64 296.35 622.34 275.14 624.31 275.14" />
				<path d="m626.43,293.33v-18.19h5.02c6.41,0,9.61,2.96,9.61,8.87,0,2.81-.89,5.07-2.68,6.77-1.78,1.7-4.16,2.55-7.14,2.55h-4.82Zm2.13-16.26v14.33h2.71c2.38,0,4.24-.64,5.57-1.92s1.99-3.09,1.99-5.43c0-4.66-2.48-6.99-7.43-6.99h-2.84Zm16.79-.03c-.37,0-.69-.13-.95-.38-.26-.25-.39-.58-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.41.58.41.96s-.14.69-.41.95c-.26.26-.58.39-.96.39Zm1.01,16.29h-2.08v-12.99h2.08v12.99Zm14.91,0h-2.08v-7.41c0-2.76-1.01-4.14-3.02-4.14-1.04,0-1.9.39-2.59,1.18-.68.78-1.01,1.76-1.01,2.96v7.41h-2.08v-12.99h2.08v2.16h.05c.98-1.64,2.4-2.46,4.26-2.46,1.42,0,2.51.46,3.26,1.38.75.91,1.13,2.24,1.13,3.97v7.94Zm4.91-16.29c-.37,0-.69-.13-.95-.38-.26-.25-.39-.58-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.41.58.41.96s-.14.69-.41.95c-.26.26-.58.39-.96.39Zm1.01,16.29h-2.08v-12.99h2.08v12.99Zm14.91,0h-2.08v-7.41c0-2.76-1.01-4.14-3.02-4.14-1.04,0-1.9.39-2.59,1.18-.68.78-1.01,1.76-1.01,2.96v7.41h-2.08v-12.99h2.08v2.16h.05c.98-1.64,2.4-2.46,4.26-2.46,1.42,0,2.51.46,3.26,1.38.75.91,1.13,2.24,1.13,3.97v7.94Zm14.93-1.04c0,4.77-2.28,7.15-6.85,7.15-1.61,0-3.01-.3-4.21-.91v-2.08c1.46.81,2.86,1.22,4.19,1.22,3.2,0,4.79-1.7,4.79-5.1v-1.42h-.05c-.99,1.66-2.48,2.49-4.46,2.49-1.62,0-2.92-.58-3.91-1.72-.98-1.16-1.47-2.71-1.47-4.66,0-2.21.53-3.96,1.59-5.26,1.07-1.3,2.52-1.95,4.36-1.95s3.05.7,3.89,2.11h.05v-1.8h2.08v11.95Zm-2.08-4.83v-1.92c0-1.03-.35-1.92-1.05-2.65-.69-.74-1.56-1.1-2.6-1.1-1.29,0-2.29.47-3.02,1.41-.73.93-1.09,2.24-1.09,3.92,0,1.45.35,2.6,1.04,3.48.7.86,1.63,1.29,2.78,1.29s2.11-.41,2.84-1.24c.74-.83,1.1-1.89,1.1-3.18Z" />
				<path d="m721.92,293.33h-2.54l-3.04-5.1c-.28-.47-.55-.88-.81-1.2-.26-.34-.53-.61-.81-.82-.27-.21-.57-.36-.89-.46-.31-.1-.67-.15-1.07-.15h-1.75v7.74h-2.13v-18.19h5.43c.79,0,1.53.1,2.19.3.68.19,1.26.49,1.75.9.5.41.89.91,1.17,1.52.28.6.42,1.31.42,2.12,0,.63-.1,1.22-.29,1.75-.19.52-.46.99-.81,1.41-.35.41-.77.77-1.27,1.07-.49.29-1.04.51-1.66.67v.05c.3.14.57.29.79.47.23.17.44.37.65.61.2.24.4.51.6.81.2.3.43.64.67,1.04l3.41,5.47Zm-10.91-16.26v6.6h2.89c.53,0,1.02-.08,1.47-.24.46-.16.85-.39,1.18-.68.33-.3.59-.67.77-1.1.19-.44.28-.93.28-1.47,0-.97-.32-1.73-.95-2.27-.63-.55-1.53-.82-2.73-.82h-2.92Zm18.48,16.57c-1.92,0-3.45-.6-4.6-1.81-1.14-1.22-1.71-2.83-1.71-4.83,0-2.18.6-3.89,1.79-5.11s2.8-1.84,4.83-1.84,3.45.6,4.53,1.79c1.09,1.19,1.64,2.85,1.64,4.96s-.59,3.73-1.76,4.98c-1.17,1.24-2.74,1.86-4.71,1.86Zm.15-11.85c-1.34,0-2.39.46-3.17,1.37-.78.9-1.17,2.16-1.17,3.75s.39,2.75,1.18,3.64,1.84,1.33,3.16,1.33,2.38-.44,3.09-1.31c.73-.87,1.09-2.11,1.09-3.72s-.36-2.88-1.09-3.75c-.72-.88-1.75-1.32-3.09-1.32h0Zm15,11.85c-1.92,0-3.45-.6-4.6-1.81-1.14-1.22-1.71-2.83-1.71-4.83,0-2.18.6-3.89,1.79-5.11,1.19-1.23,2.8-1.84,4.83-1.84s3.45.6,4.53,1.79c1.09,1.19,1.64,2.85,1.64,4.96s-.59,3.73-1.76,4.98c-1.17,1.24-2.74,1.86-4.71,1.86Zm.15-11.85c-1.34,0-2.39.46-3.17,1.37-.78.9-1.17,2.16-1.17,3.75s.39,2.75,1.18,3.64c.79.89,1.84,1.33,3.16,1.33s2.38-.44,3.09-1.31c.73-.87,1.09-2.11,1.09-3.72s-.36-2.88-1.09-3.75c-.72-.88-1.75-1.32-3.09-1.32h0Zm28.01,11.54h-2.08v-7.46c0-1.44-.22-2.48-.67-3.12-.44-.64-1.18-.96-2.23-.96-.89,0-1.64.41-2.27,1.22-.62.81-.93,1.78-.93,2.92v7.41h-2.08v-7.71c0-2.55-.99-3.83-2.96-3.83-.91,0-1.67.38-2.26,1.15-.59.76-.89,1.75-.89,2.98v7.41h-2.08v-12.99h2.08v2.05h.05c.92-1.57,2.27-2.36,4.03-2.36.89,0,1.66.25,2.32.75.66.49,1.11,1.14,1.36,1.94.96-1.79,2.4-2.69,4.31-2.69,2.86,0,4.29,1.76,4.29,5.29v8Z" />
				<path d="m610.24,320.3h-1.51v-11.43c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.7-.4,1.02-.61.32-.22.6-.42.83-.63h.57v13.52Zm10.65-9.76c0-.41-.06-.76-.19-1.06-.12-.3-.3-.55-.52-.75-.22-.2-.47-.35-.77-.45-.3-.1-.61-.15-.96-.15-.3,0-.58.04-.87.12-.28.08-.56.19-.83.33-.26.14-.52.31-.77.51-.25.2-.48.42-.69.65v-1.62c.42-.41.9-.73,1.42-.94.53-.22,1.17-.33,1.93-.33.54,0,1.04.08,1.5.24.46.15.86.38,1.2.68s.6.67.79,1.12c.2.44.3.95.3,1.52,0,.52-.06,1-.18,1.42-.12.42-.3.82-.54,1.2-.24.38-.54.73-.91,1.08-.37.34-.8.69-1.3,1.05-.62.44-1.13.82-1.54,1.13-.4.31-.72.61-.96.89-.23.27-.4.54-.5.82-.09.27-.14.58-.14.94h6.59v1.36h-8.16v-.65c0-.57.06-1.06.18-1.49s.33-.84.61-1.23c.28-.39.65-.77,1.11-1.16.46-.39,1.02-.82,1.69-1.31.48-.34.88-.67,1.2-.99.33-.31.59-.63.78-.94.2-.31.34-.63.42-.95.09-.33.13-.67.13-1.03Z" />
				<rect x="625.48" y="307.08" width="1.34" height="4.12" />
				<path d="m634.93,320.3h-1.51v-11.43c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.7-.4,1.02-.61.32-.22.6-.42.83-.63h.57v13.52Zm10.2,0h-1.51v-11.43c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.7-.4,1.02-.61.32-.22.6-.42.83-.63h.57v13.52Z" />
				<path d="m651.51,307.08v4.12h-1.34v-4.12h1.34Zm3.06,0v4.12h-1.34v-4.12h1.34Z" />
				<path d="m669.69,310.86l-3.17,4.78,3.12,4.67h-1.76l-1.85-3.06c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.43.72l-1.89,3.06h-1.74l3.22-4.63-3.08-4.81h1.76l1.83,3.23c.14.24.27.49.4.74h.04l2.36-3.97h1.67Z" />
				<path d="m681.8,320.3h-1.51v-11.43c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.7-.4,1.02-.61.32-.22.6-.42.83-.63h.57v13.52Zm12.32-3.74c0,.6-.11,1.14-.34,1.63-.22.49-.54.9-.95,1.25-.41.34-.89.61-1.47.8-.57.19-1.2.29-1.89.29-1.26,0-2.26-.24-3.01-.72v-1.62c.89.7,1.91,1.05,3.06,1.05.46,0,.88-.06,1.25-.18.38-.12.69-.29.96-.51.27-.22.48-.49.62-.8.15-.31.22-.67.22-1.06,0-1.73-1.23-2.59-3.69-2.59h-1.1v-1.28h1.04c2.18,0,3.26-.81,3.26-2.43,0-1.5-.83-2.25-2.49-2.25-.93,0-1.81.31-2.63.94v-1.47c.84-.5,1.84-.76,3.01-.76.55,0,1.05.08,1.5.23.45.15.83.37,1.15.65.32.28.57.61.74,1,.18.39.27.81.27,1.28,0,1.74-.88,2.86-2.64,3.36v.04c.45.05.86.16,1.25.33.38.17.71.38.99.65.28.27.49.59.65.96.16.36.24.77.24,1.21Z" />
				<rect x="697.04" y="307.08" width="1.34" height="4.12" />
				<path d="m709.08,312.9c0,1.21-.12,2.29-.36,3.24-.24.94-.59,1.74-1.05,2.4-.46.65-1.02,1.15-1.69,1.49-.66.34-1.42.51-2.27.51s-1.64-.15-2.31-.46v-1.45c.73.41,1.51.62,2.34.62.6,0,1.13-.12,1.6-.37.47-.25.87-.6,1.2-1.07.33-.47.57-1.05.75-1.74.17-.69.26-1.48.26-2.37h-.04c-.57,1.14-1.55,1.71-2.95,1.71-.57,0-1.09-.1-1.56-.3-.47-.2-.88-.49-1.23-.85-.34-.37-.61-.81-.8-1.31-.19-.5-.29-1.06-.29-1.67,0-.65.1-1.25.31-1.79.22-.54.51-1.01.89-1.39.38-.39.83-.7,1.35-.91.52-.22,1.09-.32,1.71-.32.66,0,1.25.14,1.76.41.52.26.95.65,1.3,1.17.35.51.62,1.14.8,1.89.18.75.28,1.61.28,2.57Zm-1.63-1.36c0-.51-.07-.97-.2-1.39-.13-.42-.31-.77-.54-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.01.22c-.31.14-.59.34-.82.61-.23.26-.41.57-.54.93-.13.36-.19.75-.19,1.17,0,.47.06.89.18,1.25.13.37.31.68.54.94.23.25.51.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.31-.14.58-.31.81-.53.23-.23.42-.49.54-.79.14-.31.2-.64.2-.99Z" />
				<path d="m712.86,307.08v4.12h-1.34v-4.12h1.34Zm3.06,0v4.12h-1.34v-4.12h1.34Z" />
				<path d="m197.27,608.59l-3.03,10.74h-1.48l-2.21-7.85c-.09-.33-.15-.7-.17-1.09h-.03c-.03.37-.09.73-.19,1.08l-2.23,7.87h-1.46l-3.15-10.74h1.39l2.29,8.24c.09.34.15.7.18,1.08h.04c.02-.26.1-.62.23-1.08l2.38-8.24h1.21l2.28,8.3c.08.28.14.62.18,1h.03c.02-.26.09-.6.2-1.03l2.2-8.27h1.36Z" />
				<polygon points="203.55 608.59 198.4 621.12 197.25 621.12 202.39 608.59 203.55 608.59" />
				<path d="m204.81,619.33v-10.74h2.97c3.79,0,5.68,1.75,5.68,5.24,0,1.66-.53,2.99-1.58,4-1.05,1-2.46,1.51-4.22,1.51h-2.85Zm1.26-9.61v8.47h1.6c1.41,0,2.5-.38,3.29-1.13.78-.75,1.18-1.82,1.18-3.21,0-2.75-1.46-4.13-4.39-4.13h-1.68Z" />
			</g>
		</g>
	)
}

export default PlanV
